<template>
    <ul class='mdl-list'>
        <li class="mdl-grid">
            <div class="mdl-cell--1-col-desktop mdl-cell--1-col-tablet">Kód&nbsp;</div>
            <div class="mdl-cell--3-col-desktop mdl-cell--2-col-tablet">Název&nbsp;</div>
            <div class="mdl-cell--1-col-desktop mdl-cell--1-col-tablet">Cena&nbsp;</div>
            <div class="mdl-cell--1-col-desktop mdl-cell--1-col-tablet">Cena s polévkou&nbsp;</div>
            <div class="mdl-cell--3-col-desktop mdl-cell--2-col-tablet">Přílohy&nbsp;</div>
            <div class="mdl-cell--2-col-desktop mdl-cell--1-col-tablet">Polévka&nbsp;</div>
            <div class="mdl-cell--1-col-desktop mdl-cell--1-col-tablet"></div>
        </li>
        <food-item-editable class="mdl-grid" v-for="(food, i) in foods" :key="food.foodId"
                          :food="food" v-on:delete-food="foods.splice(i, 1)"
                          :class="{'even' : i % 2 === 0}"
                          @save="save()">
        </food-item-editable>
        <li style="margin-top: 1em">
            <div class="mdl-chip mdl-shadow--2dp cursor-hand" v-on:click="addFood()">
                <span class="material-icons mdl-chip__text">add</span>
            </div>
        </li>
    </ul>
</template>

<script>
    import FoodItemEditable from "./FoodItemEditable";
    export default {
        name: "MenuEditFoods",
        components: {FoodItemEditable},
        props: {
            foods: Array
        },
        methods: {
            save: function () {
                this.$emit("save");
            },
            addFood: function() {
                this.foods.push({ foodCode: "", foodOptions: [], name: "", price: 0, priceWithSoup: null, soupRequired: false });
                this.save();
            },
        }
    }
</script>

<style scoped>
    .cursor-hand {
        cursor: pointer;
    }

    .even {
        background-color: #EEEEEE;
    }
</style>